import { Component } from '@angular/core';
import { AlertController, Loading, LoadingController, Platform, Events, ModalController, NavController, NavParams } from 'ionic-angular';
// import { Badge } from '@ionic-native/badge';

// O provider para se comunicar com o servidor online
import { ApiProvider } from '../../providers/api/api';

import { Storage } from '@ionic/storage';

// O provider para os dados do cliente
import { AuthProvider } from '../../providers/auth/auth';

/* Push */
import { Push, PushObject, PushOptions } from '@ionic-native/push';

import { TranslateMsgProvider } from '../../providers/translate-msg/translate-msg';
import { TutorialqrcodePage } from '../home/home';
import { MensagemPontoPage } from "../mensagem-ponto/mensagem-ponto";

@Component({
    selector: 'page-cartaofidelidade',
    templateUrl: 'cartaofidelidade.html',
})

export class CartaofidelidadePage {

    id = 0;
    estrelas = [0, 0, 0];
    loading: Loading;
    quantidadeEstrelas = 3;
    empresa = "";
    promocao = "";
    imagem = "";
    id_empresa = 0;

    temcartao;
    cartaoComCliente;
    carregando = true;

    wpp_result = {
        code: 0
    };

    constructor(private alertCtrl: AlertController, private loadingCtrl: LoadingController, private _apiService: ApiProvider, private storage: Storage, public modalCtrl: ModalController, private _auth: AuthProvider, public push: Push, private _msg: TranslateMsgProvider, public platform: Platform, public events: Events, public navCtrl: NavController, public navParams: NavParams) {
    }

    // Executar sempre que a página for aberta, mesmo se for voltando
    ionViewDidEnter() {
        if (this.navCtrl.getPrevious().name == "MensagemPontoPage") {
            this.navCtrl.remove(this.navCtrl.getPrevious().index);
        }

        var env = this;
        // Confirma login sempre que entrar na pagina
        this._auth.confirmaLogin();
        this._auth.checkempresa();

        // Apaga os badge
        // this.badge.clear();
        this.estrelas = [0, 0, 0];

        this.showLoading();

        this.storage.get('result-message').then(function (code) {
            if (code) {
                console.log("mensagem do servidor: ", code);
                env.wpp_result.code = code;
                env.storage.remove('result-message');
            }
        });

        if (this.id == 0) {
            // Primeiro pega o id do cliente
            this.storage.get('id_cliente').then((val) => {
                this.id = val;
                this.getConfigs();
            });
        }
        else {
            this.getConfigs();
        }
    }

    // Pega as configurações
    getConfigs() {
        this.carregando = true;

        // Pega o token do celular e envia para a api salvar
        this.storage.get('tokenpush').then((tok) => {
            let dadosT;

            if (this.platform.is('ios')) {
                dadosT = { token: tok, id: this.id, platform: 'ios' };
            }
            else {
                dadosT = { token: tok, id: this.id, platform: 'android' };
            }

            this._apiService.token(dadosT).subscribe(arg3 => { });
        });

        this.storage.get('id_empresa_escolhida').then((val) => {
            this.id_empresa = val;

            // Pega as configurações padrões (textoes e etc)
            this._apiService.getConfig({ id_empresa_escolhida: this.id_empresa, id_cliente: this.id }).subscribe(arg => {
                // console.log(arg);
                this.cartaoComCliente = arg.cliente;
                if (this.cartaoComCliente) {
                    /* Configuração push */
                    this.configuraPush();
                    /* Fim da Configuração push */
                }

                this.empresa = arg['nomeEmpresa'];
                this.promocao = arg['premio'];
                this.imagem = arg['imagem'];
                if (arg['total_pontos'] != '')
                    this.quantidadeEstrelas = parseInt(arg['total_pontos'], 10);
                else
                    this.quantidadeEstrelas = 0;

                this.estrelas = [];
                for (var i = 0; i < this.quantidadeEstrelas; ++i) {
                    this.estrelas[i] = 0;
                }

                let dados = { numero: this.quantidadeEstrelas, id: this.id, id_empresa_escolhida: this.id_empresa };
                // console.log(dados);

                if ((this.quantidadeEstrelas == 0) || (this.promocao == '')) {
                    this.temcartao = false;
                }
                else {
                    this.temcartao = true;
                }


                // // Pega a quantidade de estrelas marcadas
                this._apiService.getEstrelasMarcadas(dados).subscribe(arg2 => {
                    // console.log(arg2);
                    this.carregando = false;
                    this.loading.dismiss();
                    this.estrelas = arg2;
                });
            });
        });
    }

    public getClasseEstrela(num) {
        if (this.estrelas[num] == 1)
            return 'btn-star btn-star-ativo';
        else
            return 'btn-star';
    }

    /* Função para digitar a senha do admin ao clicar na estrela */
    public activeStar(num: number) {
        // Se a estrela já estiver marcada nao faz nada
        if (this.estrelas[num] == 1) {
            return false;
        }

        let conf = this.alertCtrl.create({
            title: this._msg.getMsg('ADICIONAR_TITULO'),
            message: this._msg.getMsg('ADICIONAR_OPC_2'),
            //message: this._msg.getMsg('ADICIONAR_OPC'),
            buttons: [
                //{
                //    text: this._msg.getMsg('ADICIONAR_SENHA'),
                //     handler: data => {
                //         this.addSenha(num);
                //    }
                // },
                {
                    text: this._msg.getMsg('ADICIONAR_QRCODE'),
                    handler: data => {
                        this.qrcode(num);
                    }
                }
            ]
        });
        conf.present();
    }

    public addSenha(num) {
        let prompt = this.alertCtrl.create({
            title: this._msg.getMsg('CARTAO_VALIDAR'),
            message: this._msg.getMsg('CARTAO_SENHA'),
            inputs: [
                {
                    name: 'senha',
                    placeholder: this._msg.getMsg('SENHA'),
                    type: 'password'
                },
            ],
            buttons: [
                {
                    text: this._msg.getMsg('CANCELAR'),
                },
                {
                    text: this._msg.getMsg('SALVAR'),
                    handler: data => {
                        // Exibe mensagem de carregando
                        this.showLoading();
                        let dados = { pass: data.senha, id_empresa_escolhida: this.id_empresa };
                        this._apiService.checkAdmin(dados).subscribe(arg => {
                            if (arg == 0) {
                                this.showPopup(this._msg.getMsg('ERRO'), this._msg.getMsg('CARTAO_SENHA_ERRO'));
                                return false;
                            }
                            else {
                                // Salva marcação na estrela
                                let dadosEstrela = { idAdmin: arg, idCliente: this.id, estrela: num };
                                this._apiService.salvaEstrela(dadosEstrela).subscribe(arg2 => {
                                    this.estrelas[num] = 1;
                                    this.loading.dismiss();
                                });
                            }
                        });
                    }
                }
            ]
        });
        prompt.present();
    }

    public qrcode(num) {
        let modalTutorial = this.modalCtrl.create(TutorialqrcodePage);
        modalTutorial.onDidDismiss(data => {
            this.validaPonto(data.text, num);
        });
        modalTutorial.present();
    }

    public validaPonto(data, num) {
        if (data != '') {
            let loading = this.loadingCtrl.create({
                content: this._msg.getMsg('CARREGANDO') + '...',
                dismissOnPageChange: true
            });
            loading.present();

            let envio = { id_cliente: this.id, qrcode: data, id_empresa: this.id_empresa, num: num };
            this._apiService.setPontoQrcodeEmpresa(envio).subscribe(arg => {
                loading.dismiss();

                let titulo = '';
                let tex = '';

                if (arg.erro) {
                    // titulo = 'Erro '+arg.erro;
                    titulo = this._msg.getMsg('ERRO');
                    tex = arg.msg;

                    let alert = this.alertCtrl.create({
                        title: titulo,
                        subTitle: tex,
                        buttons: [
                            {
                                text: 'OK'
                            }
                        ]
                    });
                    alert.present();
                }
                else {
                    this.estrelas[num] = 1;
                }
            });
        }
    }

    /* Exibe as mensagens de erro ou sucesso */
    showPopup(title, text) {
        this.loading.dismiss();
        let alert = this.alertCtrl.create({
            title: title,
            subTitle: text,
            buttons: [
                {
                    text: 'OK'
                }
            ]
        });
        alert.present();
    }

    /* Exibe mensagem de loading*/
    showLoading() {
        this.loading = this.loadingCtrl.create({
            content: this._msg.getMsg('CARREGANDO') + '...'
        });
        this.loading.present();
    }

    /* Retorna classe caso todas as estrelas tenham sido marcadas */
    getTodasEstrelas() {
        // // let classe = 'ativo';
        let classe = true;
        // console.log(this.estrelas);
        for (var i = 0; i < this.estrelas.length; ++i) {
            if (this.estrelas[i] == 0) {
                classe = false;
            }
        }
        return classe;
    }

    /* Entre no tópico */
    configuraPush() {
        if (this.platform.is('ios')) {
            this.events.publish('subs:novo', 'empresa_ios_' + this.id_empresa);
        }
        else {
            this.events.publish('subs:novo', 'empresa_' + this.id_empresa);
        }
    }

    /* Sai do projeto */
    sairPush() {
        const pushObject: PushObject = this.push.init({});
        pushObject.unsubscribe('empresa_' + this.id_empresa);
    }

    // Criar relacao
    participar() {
        this.showLoading();

        let dados = { id_empresa_escolhida: this.id_empresa, id_cliente: this.id };
        this._apiService.relacionaCliente(dados).subscribe(arg => {
            // console.log(arg);
            this.loading.dismiss();
            if (arg == 0) {
                this.showPopup(this._msg.getMsg('ERRO'), this._msg.getMsg('CARTAO_ERRO_PARTICIPACAO'));
                return false;
            }
            else if (arg.status == false) {
                this.showPopup(this._msg.getMsg('Erro'), arg.erro);
                return false;
            }
            else {
                let texto = this._msg.getMsg('CARTAO_PARTICIPANDO', this.empresa) + ".<br>";
                texto += this._msg.getMsg('CARTAO_BEMVINDO');

                let aviso = this.alertCtrl.create({
                    title: this._msg.getMsg('BEMVINDO'),
                    message: texto,
                    buttons: [{ text: 'Ok' }]
                });

                aviso.present();

                /* Configuração push */
                this.configuraPush();
                /* Fim da Configuração push */

                this.cartaoComCliente = true;
            }
        });

    }

    // Retirar participacao
    naoparticipar() {
        let aviso = this.alertCtrl.create({
            title: this._msg.getMsg('CARTAO_NAOQUERO'),
            message: this._msg.getMsg('CARTAO_NAOQUERO_ATENCAO'),
            buttons: [
                {
                    text: this._msg.getMsg('CANCELAR'),
                },
                {
                    text: this._msg.getMsg('CARTAO_NAOQUERO_SAIR'),
                    handler: data => {
                        // Exibe mensagem de carregando
                        this.showLoading();

                        let dados = { id_empresa_escolhida: this.id_empresa, id_cliente: this.id };
                        this._apiService.tiraRelacaoCliente(dados).subscribe(arg => {
                            // Sai do push
                            this.sairPush();

                            this.cartaoComCliente = false;
                            this.loading.dismiss();

                            for (var i = 0; i < this.quantidadeEstrelas; ++i) {
                                this.estrelas[i] = 0;
                            }
                        });

                    }
                }]
        });

        aviso.present();
    }

    //redirecionar para Whatsapp
    sendWhatsapp() {
        console.log('url')

        let phone = "";
        let message = this._msg.getMsg('MENSAGEM_1', this.empresa);

        this._apiService.getInformacoesEmpresa({ id_empresa_escolhida: this.id_empresa, id_cliente: this.id })
            .subscribe(arg => {
                phone = arg.empresa.cod_pais.toString() + arg.empresa.telefone.toString();

                let url = `https://wa.me/${phone}?text=${message}`;
                
                window.open(url, '_blank');
            })
    }

}



// WEBPACK FOOTER //
// ./src/pages/cartaofidelidade/cartaofidelidade.ts